export class FlatDetails {
    FlatId: number;
    FlatNo: string;
    Size: string;
    Face: string;
    NoOfBeds: number;
    Price: number;
    FloorName: string;
    BlockName: string;
    AmountPaid: number;
    PaidAmount: number;
    UnitType:string;
    mer_amount:number;
    Image2D:string;
    Image3D:string;
    FaceView:string;
    TotalAmount:number;
    ParkingCost:number;
    BasicCost:number;
    BasicSaleConsideration:number;
    BasicTax:number;
    ParkingSaleConsideration:number;
    ParkingTax:number;
    ClubHouseCost:number;
    ClubHouseTax:number;
    InfrastructureCost:number;
    InfraStctureSaleConsideration:number;
    InfraStrcutreTax:number;
    EastFacingPlc:number;
    EastFacingSaleConsideration:number;
    EastFacingTax:number;
    FloorRisePlc:number;
    FloorRisePlcConsideration:number;
    FloorRisePlcTax:number;
    TotalBasicPrice:number;
    TotalCarParkigCost:number;
    TotalClubHouse:number;
    TotalInfraStructure:number;
    TotalEastFacing:number;
    TotalFloorRise:number;
    TotalSaleConsideration:number;
    TotalTax:number;
    TotalCostofFlat:number;
    MaintenanceCharges:number;
    MaintenanceChargesTax:number;
    TotalMaintenanceCharges:number;
    CarpusFund:number;
    CarpusPaid: number;
    MaintenancePaid: number;
}

